<div class="c">
    <form class="upcard">

        <div class="credit">
            <p>{{publicservice.Texts.Texts['main-page1']}}</p>
            <p>2000</p>
        </div>

    </form>

    <div class="logodiv">
        <img class="logoicon" src="assets/images/recycle.png">
    </div>



    <div class="divmenu">
        <div class="wrapper">
            <form class="menu-mainpage">

                <div class="tableicon">
                   
                    <div class="r1">
                        <div class="profileicon">
                            <button mat-fab color="white" style="color:#67b758" aria-label="profile icon">
                                <mat-icon>credit_card</mat-icon>
                            </button>
                            <p class="iconText" style="padding-bottom: 30%;">{{publicservice.Texts.Texts['main-page2']}}</p>
                        </div>
                        <div class="profileicon">
                            <button mat-fab color="white" style="color:#67b758" aria-label="profile icon">
                                <mat-icon>perm_identity</mat-icon>
                            </button>
                            <p class="iconText">{{publicservice.Texts.Texts['main-page4']}}</p>
                        </div>
                    </div>
                    <div class="r2">
                        <div class="profileicon">
                            <button mat-fab aria-label="profile icon" class="addreqbtn">
                                <mat-icon>add_circle_outline</mat-icon>
                            </button>
                            <p class="iconText"  style="padding-bottom: 20%;">{{publicservice.Texts.Texts['main-page3']}}</p>
                        </div>
                        <div class="profileicon">
                            <button mat-fab color="white" style="color:#67b758" aria-label="profile icon">
                                <mat-icon>perm_identity</mat-icon>
                            </button>
                            <p class="iconText">{{publicservice.Texts.Texts['main-page4']}}</p>
                        </div>
                    </div>

                    <div class="r3">
                        <div class="profileicon">
                            <!-- <a routerLink="/get-location">   -->
                                <button mat-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="profileClick()">
                                <mat-icon>perm_identity</mat-icon>
                            </button>
                        <!-- </a> -->
                            <p class="iconText" style="padding-bottom: 35%;">{{publicservice.Texts.Texts['main-page4']}}</p>
                        </div>
                        <div class="profileicon">
                            <button mat-fab color="white" style="color:#67b758" aria-label="profile icon">
                                <mat-icon>perm_identity</mat-icon>
                            </button>
                            <p class="iconText">{{publicservice.Texts.Texts['main-page4']}}</p>
                        </div>
                       
                    </div>

                </div>
            </form>

            <!-- <form class="scoreform">
                <div class="score"> -->
            <div class="scorerow">
                <p style="margin:auto 0">50 :امتیاز</p>
                <img class="diamondicon" src="assets/images/gems.png">
            </div>
            <!-- </div>
            </form> -->

        </div>


    </div>


    <div class="scorerow1">
        <p style="margin:auto 0">50 :امتیاز</p>
        <img class="diamondicon" src="assets/images/gems.png">
    </div>

    <!-- <div class="score">
        <p>:امتیاز</p>
        <img class="diamondicon" src="assets/images/diamond.png">
    </div>  -->


</div>